import React from "react"
import styled from "styled-components"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"
import { getCssSizeValue } from "@/utils/utils"
import { ICONS } from "@/constants"
import CommonIcon from "@/components/common/Icon/Icon"
import { useDispatch } from "react-redux"
import { setHasConsent } from "@/state/cookiesSlice"

const Wrapper = styled.div`
	border: 1px solid var(--color);
	width: fit-content;
	--color: ${({ theme }) => theme.colors.richBlack};

	transition: all var(--rgr-duration) var(--ease);

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		&:hover {
			background: ${({ theme }) => theme.colors.periwinkle};
		}
	}

	cursor: pointer;
	display: flex;
	gap: ${getCssSizeValue(24)};
	align-items: center;
	padding: ${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(54, BREAKPOINTS.MOBILE)}
		${getCssSizeValue(13, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(13)} ${getCssSizeValue(54)} ${getCssSizeValue(13)} ${getCssSizeValue(16)};
	}
`

const Icon = styled(CommonIcon)`
	width: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
`

export default function CookieButton({ data }) {
	const dispatch = useDispatch()

	const text = data?.text || ""
	return (
		<Wrapper
			className="col-desktop-5 col-tablet-6 col-mobile-8"
			onClick={() => {
				dispatch(setHasConsent(false))
			}}
		>
			<Icon name={ICONS.COOKIE} color={colors.richBlack} />
			<p className="typo-strawford typo-strawford-12">{text}</p>
		</Wrapper>
	)
}
